import React from 'react'
import { AuthProvider } from 'oidc-react'

import { AuthProviderHOCProps } from './types'

const AuthProviderHOC: React.FC<AuthProviderHOCProps> = ({ config, children }) => {
	if (!config) {
		return <>{children}</>
	}

	return <AuthProvider {...config} children={children} />
}

export default AuthProviderHOC
